export default "__VITE_ASSET__q3YTgNbL__"